import { useTranslation } from 'next-i18next';
import React from 'react';

import { Typography } from '@/shared/components/atoms';
import CardRow from '@/shared/components/atoms/CardRow';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';

import ClipboardIcon from '~/images/shared/Clipboard.svg';
import CheckedClipboard from '~/images/shared/clipboard-tick.svg';

const Notes: React.FC<{
  startNote?: string | null;
  endNote?: string | null;
}> = ({ startNote, endNote }) => {
  const { t } = useTranslation();

  const cardItems: IIconWithTitleDescriptionProps[] = [
    {
      title: t('operation-creation-notes'),
      description: startNote ?? '-',
      titleTypography: {
        className: 'text-surface-10',
        variant: 'body2',
      },
      descriptionTypography: {
        variant: 'body2',
        weight: 'medium',
      },
      icon: <ClipboardIcon width='24' height='24' />,
    },
    {
      title: t('operation-ending-notes'),
      description: endNote ?? '-',
      titleTypography: {
        className: 'text-surface-10',
        variant: 'body2',
      },
      descriptionTypography: {
        variant: 'body2',
        weight: 'medium',
      },
      icon: <CheckedClipboard width='24' height='24' />,
    },
  ];

  return (
    <div>
      <Typography variant='h3' weight='bold' className='mb-16'>
        {t('notes')}
      </Typography>
      <CardRow cardItems={cardItems} />
    </div>
  );
};

export default Notes;
